import createClient from "openapi-fetch";
import { serviceURL } from "../../utils/service-url";

import type { paths } from "../../__definitions__/self-driving.changeengine.com-definitions";

export const selfDriving = createClient<paths>({
  baseUrl: serviceURL("self-driving"),
  headers: {
    "Content-Type": "application/json",
  },
});
